export default __webpack_public_path__ + "static/media/mepExpand3.6686124d.jpg";